import React from 'react';
import { makeStyles, createStyles, Theme, withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import Button from '@material-ui/core/Button';
import { purple, green, red, blue, indigo, teal } from '@material-ui/core/colors';
import CustomButton from './CustomButton';
import Box from '@material-ui/core/Box';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import PhoneEnabledIcon from '@material-ui/icons/PhoneEnabled';

// スタイルを定義
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(2),
      flexGrow: 1,
    },
  })
);

function Recruit() {
  const classes = useStyles();
  const preventDefault = event => event.preventDefault();
  return (
    <div className={classes.root}>
      <div className="wraper">

        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            キャリア採用　募集要項
          </Typography>
          キャリア採用（社会人）の募集は終了しました。<br/>
        </Box>

        {/*
        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            キャリア採用　募集要項
          </Typography>
          デーリー東北新聞社は次の職種でキャリア採用（社会人）の社員を募集します。<br/>
        </Box>

        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            （１）職　種
          </Typography>
          印刷部門
        </Box>

        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            （２）採用人員
          </Typography>
          １名
        </Box>

        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            （３）応募資格
          </Typography>
          機械、電気の整備経験がある方で、学歴は高校以上。年齢は問いません。<br />
          普通自動車運転免許は必要です（ＡＴ車限定可。入社日までに取得のこと）。<br />
        </Box>

        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            （４）勤　務
          </Typography>
          交代制（シフト制）<br />
          ①１５時００分　～　２３時００分<br />
          ②２０時００分　～　０４時００分<br />
          ※業務により上記２つ以外の就業時間にシフトすることがあります。<br />
        </Box>

        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            （５）賃　金
          </Typography>
          １６３，９５０円　～　２５０，０００円<br />
          （初任給は、年齢および職務経験等により決定します）<br />
        </Box>

        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            （６）入社時期
          </Typography>
          令和４年４月１日<br />
        </Box>

        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            （７）応募書類
          </Typography>
          ①ハローワーク紹介状<br />
          ②弊社所定の履歴書・・・写真は６カ月以内に撮影した、帽子を着用していない、上半身正面向きで本人と確認できるものを貼り付けてください。大きさは縦４センチ、横３センチです。<br />
          ③職務経歴書（書式自由）<br />
          <div class="fs90 font-weight-bold">
            ※提出書類は返却しません。応募者の個人情報は採用選考の目的のみに利用し、適正に管理・廃棄します。<br />
          </div>
        </Box>

        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            （８）応募方法
          </Typography>
          上記応募書類を２月２１日（月）までに本社総務部へ持参または郵送してください。<br />
          履歴書は本社総務部にあります（受け取り、提出とも代理可）。<br />
          下記からもダウンロードできます
          <Box my={4} textAlign="center">
            <Grid className="p-3" spacing={0} container direction="row" justify="center">
              <Grid item xs={12} md={4}>
                <CustomButton id="rirekiDL" href="/pdf/recruit/2021/rireki_carrier.pdf" className="px-4 m-2 d-block" size="large" themeColor={teal} onclick="ga('send', 'event', 'rirekiDL', 'rirekiDL', 'rirekiDL', true);">
                  履歴書のダウンロードはこちらから<br />
                </CustomButton>
              </Grid>
            </Grid>
          </Box>
        </Box>

        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            （９）選考方法
          </Typography>
          書類選考を行い、作文・適性検査・面接試験を実施します。<br />
          書類選考結果は、書類到着後１カ月以内に郵便で通知します。<br />
        </Box>

        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            （１０）試験会場
          </Typography>
          株式会社デーリー東北新聞社<br />
          青森県八戸市城下１丁目３−１２<br />
        </Box>

        <Divider />

        <Box my={8}>
          <dl>
            <dt>【付 記】</dt>
            <dd>
              <div class="font-weight-bold">◇賞与</div>
              夏季、秋季、冬季、春季の年４回<br />
              <div class="font-weight-bold">◇休日</div>
              土・日・祝日に相当する年間最大１１９日（２０２０年度実績）<br />
              ※その他年次有給休暇等あり<br />
              <div class="font-weight-bold">◇試用期間</div>
              採用後６カ月を経て正社員となります<br />
            </dd>
          </dl>
        </Box>

        <Box my={8}>
          <dl>
            <dt>【お問い合わせ先】</dt>
            <dd>
              株式会社デーリー東北新聞社 企画総務局総務部<br />
              〒０３１ー８６０１ 青森県八戸市城下１丁目３−１２<br />
              <PhoneEnabledIcon /> ０１７８－４４－５１１１<br />
              メール　daily-jinji@daily-tohoku.co.jp<br />
              ※会社説明、案内等は随時受け付けています。ご連絡ください。<br />
            </dd>
          </dl>
        </Box>
        */}

{/*
        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            過去10年間の採用実績（大学・大学院卒）
          </Typography>
          <Grid spacing={0} container direction="row" justify="center">
            <Grid item xs={12} md={8}>
              <TableContainer component={Paper}>
                <Table className={classes.table} aria-label="customized table">
                  <TableBody>
                    {recruitRows.map(row => (
                      <StyledTableRow key={row.year}>
                        <StyledTableCell component="th" scope="row" align="left">
                          {row.year}
                        </StyledTableCell>
                        <StyledTableCell align="left">{row.result}</StyledTableCell>
                      </StyledTableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>
        </Box>
*/}
        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            職場紹介
          </Typography>
          <dl>
            <dt>報道部</dt>
            <dd>
            　記者が所属するセクションです。政治、経済、事件事故、教育、スポーツなど幅広い分野の中で、記者は常にアンテナを張り巡らせ、使命感を持ってニュースを追いかけています。
            </dd>
            <dt>整理部</dt>
            <dd>
            　記者が書いた原稿に見出しを付けたり、レイアウトしたりして紙面に仕立てる部署です。まさに〝新聞づくり〟の現場といえます。
            </dd>
            <dt>読者コミュニケーション部</dt>
            <dd>
            　当社の主催事業や読者クラブの運営、マスコットキャラクター・デリオンのPR活動などを担っています。学校現場で新聞を活用するNIE（newspaper in education）なども推進する部署です。
            </dd>
            <dt>販売部</dt>
            <dd>
            　紙の新聞はもちろん、デジタル版も含めた「デーリー東北」を一人でも多くの方に購読してもらうため、配達を担う各エリアの新聞販売店とも協力しながら普及計画などを立案しています。
            </dd>
            <dt>東北のデザイン社</dt>
            <dd>
            　当社のデザイン部門から生まれたデザイン会社です。「はなすことから生まれるデザイン」をモットーに、紙面、広告などの紙媒体はもちろん、社内外のウェブデザイン、写真・動画撮影なども行っています。デザインを手掛けた本紙のラッピング紙面「エコノミック・マンデー」はグッドデザイン賞にも選ばれています。
            </dd>
            <dt>システム開発部</dt>
            <dd>
            　ホームページやデーリー東北アプリを含め、会社にある全システムの管理・運用を行っています。パソコンの修理からネットワークの管理、プログラム開発まで幅広い技術で活動しています。
            </dd>
            <dt>業務推進部</dt>
            <dd>
            　クライアントの課題解決型ビジネス、新規ソリューションの検討・実施、営業支援、ライティングを中心としたコンテンツ制作、行政・各団体への提案等、地域ビジネス局のブレーンとなる部署です。																					
            </dd>
            <dt>たびーぐ</dt>
            <dd>
            　青森県内唯一のＪＴＢ総合提携店として、店頭でＪＴＢの旅行商品やＪＲ券などを販売しています。また団体部門では、小・中・高校の修学旅行や企業の職員旅行等を取り扱っています。
            </dd>
            <dt>営業部</dt>
            <dd>
            　主に新聞広告を取り扱う部署です。営業、求人から落成、周年、葬儀まで直接お客様と打ち合わせをし、暮らしに役立つ確かな情報をお届けしています。																	
            </dd>
          </dl>
        </Box>

        {/* <Box my={8}>
          <dl>
            <dt>【過去10年間の採用実績(大学・大学院卒)】</dt>
            <dd>
              ○２０１２（平成２４）年度　３人（編集３人）<br />
              ○２０１３（平成２５）年度　６人（編集６人）<br />
              ○２０１４（平成２６）年度　９人（編集３人、営業３人、グラフィック３人）<br />
              ○２０１５（平成２７）年度　８人（編集６人、システム技術２人）<br />
              ○２０１６（平成２８）年度　６人（編集５人、営業１人）<br />
              ○２０１７（平成２９）年度　６人（編集４人、制作技術１人、営業１人）<br />
              ○２０１８（平成３０）年度　５人（編集４人、営業１人）<br />
              ○２０１９（平成３１）年度　３人（編集３人）<br />
              ○２０２０（令和２）年度　３人（編集３人）<br />
              ○２０２１（令和３）年度　２人（編集２人）<br />
            </dd>
          </dl>
        </Box> */}
        <Box my={8}>
          <Grid spacing={1} container direction="row" justify="center" alignItems="center">
            <Grid item xs={12} sm={12} md={8}>
              <div class="iframe-wrap video my-3">
                <iframe src="https://www.youtube.com/embed/zVBYEokhd_Q" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"></iframe>
              </div>
            </Grid>
          </Grid>
        </Box>
        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            ２０２２年度社員採用について
          </Typography>
          <div className="text-left">
            ２０２２年度採用募集は終了しました。<br/>
          </div>
        </Box>

        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            お問い合わせ
          </Typography>
          <dl>
            <dd>
              〒031-8601　青森県八戸市城下１丁目３-12<br/>
              株式会社デーリー東北新聞社　企画総務局総務部<br/>
              <PhoneEnabledIcon /> 0178-44-5111<br/>
              ※会社説明会等は随時受け付けています。ご連絡下さい。
            </dd>
          </dl>
        </Box>
     </div>
   </div>
  );
}

export default Recruit;
